import {
    Directive,
    ElementRef,
    Input,
    OnChanges,
    Renderer2,
    SimpleChanges
} from '@angular/core';

@Directive({
    selector: '[appHighlightText]'
})
export class HighlightTextDirective implements OnChanges {
    @Input('appHighlightText') text = '';
    @Input() highlightTerm = '';

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    ngOnChanges(_: SimpleChanges): void {
        this.applyHighlight();
    }

    private applyHighlight(): void {
        const element = this.el.nativeElement;

        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }

        if (!this.highlightTerm) {
            this.renderer.appendChild(element, this.renderer.createText(this.text));
            return;
        }

        //TODO: Check comma bs
        const terms = this.highlightTerm.split(',').map(term => term.trim()).filter(term => term.length > 0);
        const regexes = terms.map(term => new RegExp(`(${this.escapeRegex(term)})`, 'gi'));
        const parts = this.text.split(',');

        parts.forEach((part, index) => {
            const matchingRegex = regexes.find(regex => regex.test(part));
            if (matchingRegex) {
                const subParts = part.split(matchingRegex);
                this.appendSubParts(element, subParts, matchingRegex);
            } else {
                this.renderer.appendChild(element, this.renderer.createText(part));
            }

            if (parts.length > 1 && index < parts.length - 1) {
                this.renderer.appendChild(element, this.renderer.createText(', '));
            }
        });
    }

    private appendSubParts(element: any, subParts: string[], regex: RegExp): void {
        for (const subPart of subParts) {
            if (regex.test(subPart)) {
                const mark = this.renderer.createElement('mark');
                const markText = this.renderer.createText(subPart);
                this.renderer.appendChild(mark, markText);
                this.renderer.appendChild(element, mark);
            } else {
                this.renderer.appendChild(element, this.renderer.createText(subPart));
            }
        }
    }

    private escapeRegex(term: string): string {
        return term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
}
